import { getTranslatedText, BackgroundIcon, T2, B1 } from '@nile/components';
import { Button } from '@superops/ui-design-system';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

const IMPORT_TYPE = {
  technician: 'TECHNICIAN',
  requester: 'REQUESTER'
};

const ImportSummaryCard = injectIntl((props) => {
  const { data, toggleCollapsible, intl, type } = props;

  const helpTextMap = {
    [IMPORT_TYPE.technician]: {
      successCount: 'admin.technicians.import.technician.success',
      failureCount: 'admin.technicians.import.technician.error'
    },
    [IMPORT_TYPE.requester]: {
      successCount: 'admin.technicians.import.requester.success',
      failureCount: 'admin.technicians.import.requester.error'
    }
  };

  const summaryList = [
    {
      id: 'successCount',
      icon: 'SuccessCircle',
      text: helpTextMap[type].successCount
    }
    // {
    //   id: 'failureCount',
    //   icon: 'RejectedCircle.svg',
    //   text: helpTextMap[type].failureCount,
    //   button: {
    //     name: 'admin.technicians.import.viewAll',
    //     action: toggleCollapsible
    //   }
    // }
  ];

  return (
    <ImportCardWrapper className="p20 mt-20 br10">
      <div className="flex actr mb-10">
        <div className="fx center mr-10">
          <SVGIcon name="Refresh" size="lg" />
        </div>
        <B1 className="flex actr">
          <FormattedMessage id="admin.technicians.import.lastimport" />
          {/* <DateTimeFormatter type="dateTime" date={data?.lastSyncedAt} /> */}
        </B1>
      </div>
      <div>
        {summaryList?.map((item) => (
          <div className="flex actr">
            <div className="fx center mr-10">
              <SVGIcon name={item.icon} color={item.iconColor || ''} />
            </div>
            <div>
              {`${data?.[item.id]} ${getTranslatedText(intl, item.text)}`}
            </div>
            {data?.[item.id] > 0 && item?.button && (
              <div className="ml-10">
                <Button plain onClick={item?.button?.action}>
                  <FormattedMessage id={item?.button?.name} />
                </Button>
              </div>
            )}
          </div>
        ))}
      </div>
    </ImportCardWrapper>
  );
});

const ImportCardWrapper = styled.div`
  background-color: #eaeafa77;
`;

const ErrorCardWrapper = styled.div`
  .theader {
    padding: 15px;
    border: 1px solid #e3e3e3;
  }
  .px-15 {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const ErrorCard = (props) => {
  const { data } = props;
  return (
    <ErrorCardWrapper className="mt-20">
      <div className="flex actr theader uppercase">
        <div className="fx2">
          <T2>
            <FormattedMessage id="admin.technicians.import.table.email" />
          </T2>
        </div>
        <div className="fx2">
          <T2>
            <FormattedMessage id="admin.technicians.import.table.importError" />
          </T2>
        </div>
      </div>
      {data?.map((err) => (
        <div className="flex actr">
          <div className="fx2">
            <B1 className="p10 px-15 ellipsis">{err?.email}</B1>
          </div>
          <div className="fx2">
            <div className="flex actr">
              <div className="fx center mr-10">
                <SVGIcon name="RejectedCircle" color="#E72F23" />
              </div>
              <div>
                <FormattedMessage id={`app.errorCode.${err?.importError}`} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </ErrorCardWrapper>
  );
};

export { ImportSummaryCard, ErrorCard, IMPORT_TYPE };
